import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {LastMatchesLayoutDataColumnDomainModel} from "./game-h2h.competitor.layout-data.column.domain-model";
import {LastMatchesLayoutDataColumnApiModel} from "./game-h2h.competitor.layout-data.column.api-model";
import {GameH2hCompetitorLayoutDataApiModel} from "./game-h2h.competitor.layout-data.api-model";

export class GameH2hCompetitorLayoutDataDomainModel extends BaseDomainModel {
  apiModel: GameH2hCompetitorLayoutDataApiModel;

  get columns(): Array<LastMatchesLayoutDataColumnDomainModel> {
    return this.apiModel.columns?.map((column: LastMatchesLayoutDataColumnApiModel) => new LastMatchesLayoutDataColumnDomainModel(column))
  }
}